import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-taluk-grid',
  templateUrl: './taluk-grid.component.html',
  styleUrls: ['./taluk-grid.component.css']
})
export class TalukGridComponent implements OnInit {

  title = "Taluk List";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/masters/taluk/taluk-grid/taluk-grid.component.ts